import { PricingPageLegacy } from "../PricingPageLegacy/PricingPageLegacy";

export default PricingPageLegacy;
